import { Injectable } from '@angular/core'
import firebase from 'firebase/app'
import 'firebase/firestore'
import { AngularFirestore } from '@angular/fire/firestore'
import { UserService } from '../user.service'
import { HistoryModel } from '../../models/history.model'
import { Observable } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class HistoryService {
  constructor(private firestore: AngularFirestore, private userService: UserService) {}

  async logAction(action: string, userId: string, details?: any) {
    const userName = await this.userService.getUserName(userId)
    const historyEntry: HistoryModel = {
      timestamp: firebase.firestore.FieldValue.serverTimestamp(),
      userId,
      userName,
      action,
      ...details,
    }
    return this.firestore.collection('history').add(historyEntry)
  }

  getAllHistory(): Observable<(HistoryModel & { id: string })[]> {
    return this.firestore
      .collection<HistoryModel>('history', ref => ref.orderBy('timestamp', 'desc'))
      .valueChanges({ idField: 'id' })
  }
}
